import { render, staticRenderFns } from "./InformacionCita.vue?vue&type=template&id=6f458776"
import script from "./InformacionCita.vue?vue&type=script&lang=js"
export * from "./InformacionCita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports